<template>
  <basic-container>
    <avue-crud
      :option="option"
      :table-loading="loading"
      :data="data"
      :page.sync="page"
      :permission="permissionList"
      :before-open="beforeOpen"
      v-model="form"
      ref="crud"
      @row-update="rowUpdate"
      @row-save="rowSave"
      @row-del="rowDel"
      @search-change="searchChange"
      @search-reset="searchReset"
      @selection-change="selectionChange"
      @current-change="currentChange"
      @size-change="sizeChange"
      @on-load="onLoad"
      @refresh-change="onLoad"
    >
      <template slot="menuLeft">
        <el-button
          type="danger"
          size="small"
          icon="el-icon-delete"
          plain
          v-if="permission.inspectproject_delete"
          @click="handleDelete"
          >删 除
        </el-button>
      </template>
    </avue-crud>
  </basic-container>
</template>

<script>
import {
  inspectProjectAdd,
  inspectProjectGetDetail,
  getList,
  inspectProjectRemove,
  inspectProjectUpdate,
} from '@/api/v4ward/inspectproject/inspectproject';
import { mapGetters } from 'vuex';

export default {
  data() {
    return {
      form: {},
      query: {},
      loading: true,
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      selectionList: [],
      option: {
        height: 'auto',
        calcHeight: 'auto',
        tip: false,
        border: true,
        index: true,
        indexLabel: '序号',
        viewBtn: false,
        editBtn: true,
        selection: true,
        columnBtn: false,
        refreshBtn: false,
        column: [
          {
            label: '主键',
            prop: 'id',
            hide: true,
            editDisplay: false,
            addDisplay: false,
            viewDisplay: false,
            rules: [
              {
                required: true,
                message: '请输入主键',
                trigger: 'change',
              },
            ],
          },
          {
            label: '通用项',
            prop: 'equipmentName',
            editDisplay: false,
            addDisplay: false,
            width: 150,
            rules: [
              {
                required: true,
                message: '请输入设备名称',
                trigger: 'change',
              },
            ],
          },
          {
            label: '巡检内容',
            prop: 'inspectContentSearch',
            search: true,
            hide: true,
            editDisplay: false,
            addDisplay: false,
            viewDisplay: false,
            searchPlaceholder: '模糊匹配巡检内容',
            maxlength: 200,
            showWordLimit: true,
          },
          {
            label: '巡检内容',
            type: 'textarea',
            prop: 'inspectContent',
            labelWidth: 200,
            span: 20,
            row: 2,
            maxlength: 200,
            showWordLimit: true,
            rules: [
              {
                required: true,
                message: '请输入巡检内容',
                trigger: 'blur',
              },
            ],
          },
        ],
      },
      data: [],
    };
  },
  computed: {
    ...mapGetters(['permission']),
    permissionList() {
      return {
        addBtn: this.vaildData(this.permission.inspectproject_add, false),
        viewBtn: this.vaildData(this.permission.inspectproject_view, false),
        delBtn: this.vaildData(this.permission.inspectproject_delete, false),
        editBtn: this.vaildData(this.permission.inspectproject_edit, false),
      };
    },
    ids() {
      let ids = [];
      this.selectionList.forEach((ele) => {
        ids.push(ele.id);
      });
      return ids.join(',');
    },
  },
  methods: {
    rowSave(row, loading, done) {
      inspectProjectAdd(row).then(
        () => {
          loading();
          this.onLoad();
          this.$message.success('操作成功!');
        },
        (error) => {
          done();
          console.log(error);
        }
      );
    },
    rowUpdate(row, index, loading, done) {
      inspectProjectUpdate(row).then(
        () => {
          loading();
          this.onLoad();
          this.$message.success('操作成功!');
        },
        (error) => {
          done();
          console.log(error);
        }
      );
    },
    rowDel(row) {
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return inspectProjectRemove({ ids: row.id });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
        });
    },
    handleDelete() {
      if (this.selectionList.length === 0) {
        this.$message.warning('请选择至少一条数据');
        return;
      }
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return inspectProjectRemove({ ids: this.ids });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
          this.$refs.crud.toggleSelection();
        });
    },
    beforeOpen(done, type) {
      if (['edit', 'view'].includes(type)) {
        inspectProjectGetDetail({ id: this.form.id }).then(({ data }) => {
          this.form = data;
        });
      }
      done();
    },
    searchReset() {
      this.query = {};
      this.onLoad();
    },
    searchChange(params, done) {
      this.query = params;
      this.query.inspectContent = this.query.inspectContentSearch;
      this.page.currentPage = 1;
      this.onLoad();
      done();
    },
    selectionChange(list) {
      this.selectionList = list;
    },
    selectionClear() {
      this.selectionList = [];
      this.$refs.crud.toggleSelection();
    },
    currentChange(currentPage) {
      this.page.currentPage = currentPage;
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
    },
    onLoad(page) {
      page = page || this.page;
      this.loading = true;
      getList(Object.assign({ current: page.currentPage, size: page.pageSize }, this.query)).then(
        ({ data }) => {
          this.page.total = data.total;
          this.data = data.records;
          this.loading = false;
          this.selectionClear();
        }
      );
    },
  },
};
</script>

<style></style>
